import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import GovLogo from '../../../svg/GovLogo';
import '../../../App.css'
function Screen(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [curScreen, setCurScreen] = useState('/')
    useEffect(() => {
        const pathName = location.pathname.split('/')[1]
        setCurScreen(`/${pathName}`)
    }, [location])
    const navigateTo = (str) => () => {
        navigate(str)
    }

    const openNewTab = (url) => () => {
        window
            .open(url, '_blank')
            .focus();
    }


    const [isShowMoblieMenu, setisShowMoblieMenu] = useState(false)
    return (
        <div className='w-full max-w-[1300px] relative text-white flex justify-start items-stretch flex-col text-[12px] bg-main px-[64px] py-[100px]'>
            <div className="w-full flex flex-row-col items-stretch justify-start gap-104-48 flex-wrap footer-start">
                <img src='/logo.png' style={{ height: 80, aspectRatio: 136 / 95, objectFit: 'contain' }} alt='logo'></img>
                <img src='/hku.png' style={{ height: 80, objectFit: 'contain' }} alt='logo'></img>
                <GovLogo height={80} />

            </div>
            {/* mobile */}
            <div className='flex flex-row-col w-full justify-start flex-wrap items-center text-[#717171] font-[500] text-[18px] z-[1] gap-[32px] mt-[32px] footer-start'  >
                <div onClick={navigateTo('/')} style={{ color: ['/', '/home', '/index.html'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    主頁
                </div>
                <div onClick={navigateTo('/#aboutus')} style={{ color: ['/aboutus'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    關於我們
                </div>
                <div onClick={navigateTo('/details')} style={{ color: ['/details'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    參與計劃的好處
                </div>
                <div onClick={navigateTo('/register')} style={{ color: ['/register'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    學校登記
                </div>
                <div onClick={navigateTo('/#contactus')} style={{ color: ['/contactus'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    聯絡我們
                </div>
                {/* <a href='/#contactus' onClick={() => navigateTo(`/#contactus`)} style={{color:['/contactus'].includes(curScreen)?'#425596':'#000000'}} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">聯絡我們</a> */}
                <div onClick={navigateTo('/platform2')} style={{ color: ['/platform2'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    登入
                </div>
            </div>

            <div className='flex flex-row-col w-full justify-start flex-wrap items-center text-[#717171] font-[300] text-[12px] z-[1] gap-[32px] mt-[32px]'  >
                <div onClick={navigateTo('/')} style={{ color: '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    © 網讀無界
                </div>
                <div onClick={openNewTab('https://hku.hk/about/policies_reports/c_privacy_policy.html')} style={{ color: '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                    隱私權政策
                </div>
            </div>


        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Screen)